import { ResponseData } from "@/typings";
import { Message } from "@arco-design/web-react";

export function onErrorMessage(error: any) {
  const jsonString = error.message.replace("Error: ", "");
  try {
    const res = JSON.parse(jsonString) as ResponseData<any>;
    Message.error({
      content: `code: ${res.code}, message: ${res.msg}`,
      duration: 4000,
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    Message.error("api error");
  }
}
